import { CSSProperties } from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export default function Card({ children, className }: CardProps) {

  const styles: CSSProperties = {
    border: '1px solid @gray4',
    borderRadius: '5px',
    boxShadow: '0px 2px 4px 0px #A7A9AC',
    padding: '16px',
    flex: 1,
    background: '#fff'
  };


  return (
    <div className={className ?? ''} style={styles}>
      {children}
    </div>
  );
}